module.exports = __webpack_public_path__ + "static/media/Plymouth-Corners-Master-Deed.34416214.pdf";